// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1jtcs","title":"AfterBackImages_title__22zRZ","images":"AfterBackImages_images__3UA9E"};